<template>
  <div>
    <div>


        <b-card
            no-body
            border-variant="msstream"
            class="marginal"
        >

            <b-card-header
                    header-bg-variant="msstream"
                    header-text-variant="white"
                    class="text-center"
            >
                <h2>{{$ml.get('configHeader')}} {{configuration.name}}</h2>
            </b-card-header>
            <b-card-body>
                <b-row class="justify-content-center">
                    <h5>
                        {{$ml.get('quanteecKeyconfig')}} <span style="color:#2F90B0; margin-right:10px">{{configuration.key}}</span>
                        <b-button size="sm" variant="msstreamblue" @click="$refs.copied.copyToClipboard(configuration.key); showqk=true">
                            <font-awesome-icon icon="clone"></font-awesome-icon> 
                            {{$ml.get('copy')}}
                        </b-button>
                    </h5>
                </b-row>
                <b-row class="justify-content-center"><p v-html="$ml.get('keyexplainconfig')"></p></b-row>
                <b-row class="justify-content-center">
                    <b-col cols="auto">
                        <b-button variant="msstreamblue " @click="analyticsSiteGlobal()">
                            <font-awesome-icon icon="chart-line"></font-awesome-icon> Analytics
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>


        <!--<b-card
            no-body
            border-variant="msstream"
            class="marginal"
        >

            <b-card-header
                    header-bg-variant="msstream"
                    header-text-variant="white"
                    class="text-center"
            >
                <h2>{{$ml.get('authorizationheaderconfig')}}</h2>
            </b-card-header>
            <b-card-body>
                <p>TODO Later</p>
            </b-card-body>
        </b-card>-->

        <b-card
            no-body
            border-variant="msstream"
            class="marginal"
        >

            <b-card-header
                    header-bg-variant="msstream"
                    header-text-variant="white"
                    class="text-center"
            >
                <h2>{{$ml.get('siteListConfig')}}</h2>
            </b-card-header>
            <b-card-body>
                <b-row class="justify-content-center"><p>{{$ml.get('siteexplainConfig')}}</p></b-row>
                <b-form-checkbox
                    id="otherP2Pcheck"
                    v-model="otherP2P"
                    name="otherP2P"
                    @change="pushOtherP2P"
                    class="otherP2P"
                    switch
                    >
                    <font-awesome-icon v-if="otherP2P" icon="lock-open"></font-awesome-icon>
                    <font-awesome-icon v-if="!otherP2P" icon="lock"></font-awesome-icon>{{$ml.get('acceptundeclaresite')}}
                </b-form-checkbox>
                <b-table striped hover :busy="isSiteLoading" :items="sites" :fields="fields" class="marginaltopsm">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{$ml.get('loadingConfig')}}</strong>
                        </div>
                    </template>
                    <template #cell(Public_IPs)="row">
                        <span>[{{(row.item.publicIPs.join(', ').length > 50) ? row.item.publicIPs.join(', ').substring(0,50) + '...' : row.item.publicIPs.join(', ')}}]</span>
                    </template>
                    <template #cell(Subnets)="row">
                        <span>[{{(row.item.subNetworks.join(', ').length > 50) ? row.item.subNetworks.join(', ').substring(0,50) + '...' : row.item.subNetworks.join(', ')}}]</span>
                    </template>
                    
                    <template #cell(modif)="row">
                        <b-button variant="mswarning " @click="modifySite(row.item)">
                            <font-awesome-icon icon="pencil-alt" />
                        </b-button> &nbsp;
                        <b-button variant="greenw " @click="removeSite(undefined, row.item)">
                            <font-awesome-icon icon="trash-alt" />
                        </b-button> &nbsp;

                        <b-button variant="msstreamblue " @click="analyticsSite(undefined, row.item)">
                            <font-awesome-icon icon="chart-line"></font-awesome-icon>
                        </b-button>
                    </template>

                </b-table>
            <b-row class="justify-content-center">
                <b-col cols="auto">
                    <b-btn variant="msstreamblue" @click="addSite">Add a site</b-btn>
                </b-col>
            </b-row>
            <div v-if="isSiteFormActivated" class="marginaltop">
                <hr>
                <h3>Enter site informations</h3>
                <b-form @submit.prevent="">
                    <div>
                        <b-form-group
                            id="sitenameformlabel"
                            label="Name of the site"
                            label-for="sitenameform"
                            description=""
                        >
                            <b-form-input id="sitenameform" v-model="modifiedSite.name" required></b-form-input>
                        </b-form-group>
                    </div>
                    <div>
                        <b-form-group
                            id="sitetypeformlabel"
                            label="P2P configuration"
                            label-for="sitetypeform"
                            description=""
                            
                        >
                            <b-form-select id="sitetypeform" v-model="modifiedSite.p2pType" :options="options" required></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="marginaltop">
                        <b-form @submit.prevent="addPublicIP">
                            <b-form-group
                                id="publicipsformlabel"
                                label="Public IPs"
                                label-for="publicipsform"
                                description=""
                                
                            >
                                <b-form-input id="publicipsform" :state="publicIPValidation" v-model="newPublicIP"></b-form-input>
                                <b-form-valid-feedback :state="publicIPValidation">
                                    Press ENTER to validate the IP and add it to the list
                                </b-form-valid-feedback>
                                <b-form-invalid-feedback :state="publicIPValidation">
                                    Please enter a valid IPV4 address in IP or CIDR format
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-form>
                        <b-row v-if="modifiedSite.publicIPs && modifiedSite.publicIPs.length > 0" class="marginaltopsm">
                            <b-col style="margin-bottom: 20px;" cols="auto" v-for="(publicIP, idxPublicIP) in modifiedSite.publicIPs" v-bind:key="idxPublicIP">
                                <small class="ip">{{publicIP}} <span class="ipremove" @click="removePublicIP(idxPublicIP)">X</span></small>
                            </b-col>
                        </b-row>
                    </div>
                    <div :class="{'marginaltop': modifiedSite.publicIPs.length === 0,'marginaltopsm': modifiedSite.publicIPs.length > 0}">

                        <b-form @submit.prevent="addSubnet">
                            <b-form-group
                                id="subnetsformlabel"
                                label="Subnets"
                                label-for="publicipsform"
                                description="Subnetworks in CIDR format"
                            >
                                <b-form-input id="subnetsform" :state="subnetValidation" v-model="newSubnet"></b-form-input>
                                <b-form-valid-feedback :state="subnetValidation">
                                    Press ENTER to validate the subnet and add it to the list
                                </b-form-valid-feedback>
                                <b-form-invalid-feedback :state="subnetValidation">
                                    Please enter a valid CIDR address (example: 192.168.1.0/24)
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-form>
                        <b-row v-if="modifiedSite.subNetworks && modifiedSite.subNetworks.length > 0" class="marginaltopsm">
                            <b-col style="margin-bottom: 20px;" cols="auto" v-for="(subNetwork, idxSubNetwork) in modifiedSite.subNetworks" v-bind:key="idxSubNetwork">
                                <small class="ip">{{subNetwork}} <span class="ipremove" @click="removeSubnet(idxSubNetwork)">X</span></small>
                            </b-col>
                        </b-row>
                    </div>


                    <b-row class="justify-content-end marginaltopsm">
                        <b-col cols="auto">
                            <b-btn variant="green" @click="pushSite">Save</b-btn>
                        </b-col>
                        <b-col cols="auto">
                            <b-btn variant="greenw" @click="isSiteFormActivated=false">Cancel</b-btn>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            </b-card-body>
        </b-card>


    </div>

<CopiedModal ref="copied"></CopiedModal>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import ConfigurationService from '@/services/configuration.service.js';
let configurationService = new ConfigurationService();


export default {
  name: 'configurationsite',
  props: [
    "uuid"
  ],
  components: {
    CopiedModal
  },
  watch: {
    uuid: function(newUuid) {
        this.uuid = newUuid;
        this.getSites();
    }
  },
  data() {
    return {
        isSiteLoading: false,
        configurationID: null,
        otherP2P: false,
        configuration: {},
        sites: [],
        isSiteFormActivated: false,
        modificationIndex: -1,
        fields: [
          {
            key: 'name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'Public_IPs',
            label: 'Public IPs'
            
          },
          {
            key: 'Subnets',
          },
          {
            key: 'p2pType',
            label: 'P2P activated',
            sortable: true
          },
          {
            key: 'updatedAt',
            label: 'Last updated',
            sortable: true
          },
          {
            key: 'modif',
            label: ''
          },
        ],
        options: [
          { value: "strict_subnet", text: 'Connect peers in same networks only. Peers from a site (via Public IP) but not in a known subnetwork can not use Quanteec.' },
          { value: "subnet", text: 'Connect peers in same networks only. Peers from a site (via Public IP) but not in a known subnetwork are put all together in a separated group.' },
          { value: "intrasite", text: 'Connect all peers from the same site.' },
          /*{ value: "intersite", text: 'Connect with peers from the same site or other sites' },
          { value: "on", text: 'Connect with external peers' },*/
          { value: "off", text: 'No P2P.' },
        ],
        modifiedSite: {

        },
        newPublicIP: '',
        newSubnet: ''

    }
  },
  computed: {
    publicIPValidation() {
        if (this.newPublicIP === "") {
            return null;
        } else {
            return (this.newPublicIP.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/g) !== null)
        } 
    },
    subnetValidation() {
        if (this.newSubnet === "") {
            return null;
        } else {
            return (this.newSubnet.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/g) !== null)
        } 
    }
  },
  mounted() {
    this.getSites();
  },
  methods: {
    getSites() {
        this.isSiteLoading = true
        configurationService.getConfiguration(this.uuid, this.$auth.token()).then(configuration => {
            this.sites = configuration.sites;
            this.configurationID = configuration.uuid;
            this.otherP2P =  configuration.otherP2P || false;
            this.configuration = configuration;
            this.isSiteLoading = false;
        }).catch(err => {
            //TODO show modal error
            this.isSiteLoading = false;
        })
    },
    resetSites() {
        
    },
    addPublicIP() {
        if (this.modifiedSite.publicIPs.indexOf(this.newPublicIP) === -1) {
            this.modifiedSite.publicIPs.push(this.newPublicIP);
            this.newPublicIP = "";
        }
    },
    removePublicIP(idx) {
        this.modifiedSite.publicIPs.splice(idx, 1);
        this.modifiedSite.publicIPs = this.modifiedSite.publicIPs.splice(0);
    },
    addSubnet() {
        if (this.modifiedSite.subNetworks.indexOf(this.newSubnet) === -1) {
            this.modifiedSite.subNetworks.push(this.newSubnet);
            this.newSubnet = "";
        }
    },
    removeSubnet(idx) {
        this.modifiedSite.subNetworks.splice(idx, 1);
        this.modifiedSite.subNetworks = this.modifiedSite.subNetworks.splice(0);
    },
    addSite() {
        this.modifiedSite = {
            name: "Site " + (this.sites.length+1),
            uuid: uuidv4(),
            p2pType: "strict_subnet",
            subNetworks: [],
            publicIPs: []
        }
        this.modificationIndex = -1;
        this.isSiteFormActivated = true;
    },
    modifySite(site, idx) {
        this.modifiedSite = JSON.parse(JSON.stringify(site));
        if (idx === undefined) {idx = this.sites.indexOf(site)}
        this.modificationIndex = idx;
        this.isSiteFormActivated = true;
    },
    removeSite(idx, site) {
        if (idx === undefined) {idx = this.sites.indexOf(site)}
        this.sites.splice(idx, 1);
        this.sites = this.sites.splice(0)
        configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
            this.getSites();
        }).catch(err => {
            // TODO showModal Error
        })
    },
    analyticsSite(idx, site) {
        if(idx === undefined) {idx = this.sites.indexOf(site)}
        let filter = this.configuration.uuid + "_" + this.sites[idx].uuid

        this.$router.push('/analytics?site=' + this.sites[idx].name + '&filter=' + filter);
    },
    analyticsSiteGlobal() {
        this.$router.push('/analytics?config=' + this.configuration.name + '&filter=' + this.configuration.uuid);
    },
    pushSite() {
        this.modifiedSite.updatedAt = new Date().toISOString();
        if (this.modificationIndex === -1) {
            this.sites.push(this.modifiedSite);
        } else {
            this.sites[this.modificationIndex] = JSON.parse(JSON.stringify(this.modifiedSite));
            this.sites = this.sites.splice(0);
        }
         configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
                this.addSite();
                this.isSiteFormActivated = false;
                this.getSites();
            }).catch(err => {
                // TODO showModal Error
            })
        
    },
    pushOtherP2P() {
        this.modifiedSite.updatedAt = new Date().toISOString();
         configurationService.putConfiguration(this.configurationID, {otherP2P: this.otherP2P}, this.$auth.token()).then(() => {
                this.configuration.otherP2P = this.otherP2P;
            }).catch(err => {
                // TODO showModal Error
                this.otherP2P = this.configuration.otherP2P;
            })
        
    },
    pushRules() {
        this.modifiedSite.updatedAt = new Date().toISOString();
         configurationService.putConfiguration(this.configurationID, {rules: this.rules}, this.$auth.token()).then(() => {
                this.configuration.rules = this.rules;
            }).catch(err => {
                // TODO showModal Error
                this.rules = this.configuration.rules;
            })
    }

  }


}
</script>

<style scoped lang="scss">
.otherP2P {
    border-top: solid 1px rgba(47,144,176,1);
    padding-top: 15px;
    border-bottom: solid 1px rgba(47,144,176,1);
    padding-bottom: 15px;
    background-color: rgba(47,144,176,0.2);

    padding-left: 3rem;
}
.custom-select {
    color: #2a5d77 !important;
    border-color: #2a5d77 !important;
    cursor: pointer;
}
.custom-select:hover {
    color: #048F94 !important;
}

.ip {
    background-color: rgba(47,144,176,1);
    border-radius: 5px;
    color: white;
    padding: 5px;  
}
.ipremove {
    cursor: pointer;
    margin-left: 15px;
    font-weight: 500;
    &:hover {
        color:#14BF98
    }
}

</style>
